/**
 * Рекурсивно преобразует ключи объекта согласно нотационной функции
 * @param obj Преобразуемый объект
 * @param fn Нотационная функция
 */
function recursiveRename(obj: Object, fn: Function): any {
    if (obj instanceof Array) {
        return obj.map(function (value) {
            return recursiveRename(value, fn);
        });
    } else if (obj === null || obj instanceof RegExp || obj instanceof Error || obj instanceof Date) {
        return obj;
    } else if (typeof obj === 'object') {
        const result = {};
        for (const j in obj) {
            if (obj.hasOwnProperty(j)) {
                result[fn(j)] = recursiveRename(obj[j], fn);
            }
        }
        return result;
    }
    return obj;
}

/**
 * Преобразует строку в camelCase нотацию
 * @param value Преобразуемая строка
 */
export function camelCase(value: string): string {
    const result = value.replace(/([:\-_]+(.))/g, (str, separator, letter) => letter.toUpperCase());
    return result[0].toLowerCase() + result.substring(1);
}

/**
 * Преобразует строку в pascalCase нотацию
 * @param value Преобразуемая строка
 */
export function pascalCase(value: string): string {
    const result = camelCase(value);
    return result[0].toUpperCase() + result.substring(1);
}

/**
 * Преобразует строку в snake_case нотацию
 * @param value Преобразуемая строка
 */
export function snakeCase(value: string): string {
    return value
        .replace(/([A-Z]+)/g, (str, separator) => '_' + separator)
        .replace(/(\W+)/g, '_')
        .replace(/(_+)/g, '_')
        .replace(/^(_)/g, '')
        .replace(/(_)$/g, '')
        .toLowerCase()
        .trim();
}

/**
 * Преобразует ключи объекта в PascalCase нотацию
 * @param obj Преобразуемый объект
 */
export function pascalCaseObject(obj: Object): any {
    return recursiveRename(obj, pascalCase);
}

/**
 * Преобразует ключи объекта в camelCase нотацию
 * @param obj Преобразуемый объект
 */
export function camelCaseObject(obj: Object): any {
    return recursiveRename(obj, camelCase);
}

/**
 * Преобразует ключи объекта в snake_case нотацию
 * @param obj Преобразуемый объект
 */
export function snakeCaseObject(obj: Object): any {
    return recursiveRename(obj, snakeCase);
}
